module.exports = __webpack_public_path__ + "img/icon_卡片_赛事认证@3x.159aa845.png";